import { render } from "./addChat.vue?vue&type=template&id=bec54382"
import script from "./addChat.vue?vue&type=script&lang=js"
export * from "./addChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__